/* PagingResultFeed.js */

"use strict";
const PagingFeed = require("../../../../lib/PagingFeed");

class PagingResultFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startAdHocQueryResultsFeed(this._activeOrgId, this._filter, this._entityFields, this._sort, {
            skip: 0,
            limit: this._pageSize * 2
        });
    }

    _reestablishResultFeed(filter) {
        this._filter = filter;
        return this._feedReestablish();
    }

    _getDistinctValuesOfField(tenantId, field) {
        return this._EntityDef.startAdHocQueryResultDistinctValuesFeed(tenantId, field);
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadAdHocQueryResultIdsForSelection(tenantId, selection);
    }

    getResultEntitiesById(ids) {
        return this.getEntitiesById(ids);
    }

    getResultEntityById(id) {
        return this.getEntityById(id);
    }
}

module.exports = PagingResultFeed;
